<template>
  <v-toolbar :color="ui.cardColor">
    <v-toolbar-title :class="ui.textSubheadingBold">
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
        <v-icon> warning </v-icon>
        </v-avatar>
        {{logObj.title}}
      </v-chip>
    </v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getCurrentPage"]),
    logObj() {
      let obj = {
        title: ""
      };
      if (this.getCurrentPage === "/companymanagement") {
        obj.title = "Empty Company Log";
      } else {
        obj.title = "Empty Log";
      }
      return obj;
    }
  },
  mixins: [apptheme, licenceFunctions, adminFunctions],
  data() {
    return {
      valid: true
    };
  }
};
</script>
